import React, { useMemo, useState } from 'react';
import dynamic from 'next/dynamic';
import clsx from 'clsx';
import HeaderLogo from 'components/commercetools-ui/organisms/header/header-logo';
import HeaderNavigationMobile from 'components/commercetools-ui/organisms/header/header-navigation/header-navigation-mobile';
import { HeaderProps } from 'components/commercetools-ui/organisms/header/types';
import UtilitySection from 'components/commercetools-ui/organisms/header/utility-section';
import useMediaQuery from 'helpers/hooks/useMediaQuery';
import { desktop } from 'helpers/utils/screensizes';
import { HeaderContentProps } from './types/gmsb-header';

const CommercetoolsSearch = dynamic(() => import('components/commercetools-ui/atoms/search'));

const Header: React.FC<HeaderProps & HeaderContentProps> = ({
  carts,
  wishlist,
  categories,
  searchItems,
  searchKeywords,
  onSearchQueryUpdate,
  contentConfig,
  announcementBarData,
  recommendations,
}) => {
  const Search = CommercetoolsSearch;
  const [isDesktopSize] = useMediaQuery(desktop);
  const [showSearchMobile, setShowSearchMobile] = useState(false);
  const { ariaLabelLogo } = contentConfig;
  const isAnnouncementBar = announcementBarData?.render;

  const headerPositionClass = useMemo(() => {
    if (isAnnouncementBar) {
      return 'fixed w-full z-10 px-0 top-28 reg:top-40 border-b border-[#eee]';
    } else {
      return 'fixed w-full z-10 px-0 top-0 border-b border-[#eee]';
    }
  }, [isAnnouncementBar]);

  const headerClass = clsx('left-0', headerPositionClass);



  return (
    <header className={headerClass} data-testid="sticky-status">
      <div
        aria-label="Top"
        className={`z-30 flex w-full items-center justify-between rounded-none bg-white px-16 shadow-[0px_5px_8px_0px_#0000000D] dark:border-y dark:border-solid dark:border-[#FFFFFF33] dark:bg-gmsb-header-gray md:px-24`}
      >
        {!isDesktopSize && (
          <HeaderNavigationMobile
            contentConfig={contentConfig}
            ariaLabelLogo={ariaLabelLogo}
            wishlist={wishlist}
            imageClassName="flex justify-center text-center text-16 font-bold md:text-28"
          />
        )}
        <div className="flex-0 mx-0 flex justify-start md:mr-10 lg:mr-0">
          <HeaderLogo
            contentConfig={contentConfig}
            isDesktopSize={isDesktopSize}
            ariaLabelLogo={ariaLabelLogo}
            imageClassName="flex justify-center text-center text-16 font-bold md:text-28 object-scale-down"
          />
        </div>
        {isDesktopSize && (
          <div className="relative flex w-full flex-1 py-10 md:mr-4 lg:px-20 xl:block 2xl:px-72">
            <Search
              categories={categories}
              contentConfig={contentConfig}
              items={searchItems}
              onQueryUpdate={onSearchQueryUpdate}
              searchKeywords={searchKeywords}
              recommendations={recommendations}
            />
          </div>
        )}

        <UtilitySection
          carts={carts}
          wishlist={wishlist}
          contentConfig={contentConfig}
          showSearchMobile={showSearchMobile}
          showSearchBarMobile={() => setShowSearchMobile(!showSearchMobile)}
        />
      </div>
      {showSearchMobile && (
        <div className="relative mt-12 block w-full px-16 sm:border-0 md:px-24 lg:px-20 xl:hidden xl:rounded-2xl xl:px-48">
          <Search
            categories={categories}
            contentConfig={contentConfig}
            items={searchItems}
            onQueryUpdate={onSearchQueryUpdate}
            searchKeywords={searchKeywords}
            recommendations={recommendations}
            showSearchMobile={showSearchMobile}
            showSearchBarMobile={() => setShowSearchMobile(!showSearchMobile)}
          />
        </div>
      )}
      {/* <HeaderNavigationDesktop links={navLinks} tiles={tiles ?? []} /> */}
    </header>
  );
};
export default Header;
